import React, { ReactElement } from "react";
import styles from "./breadcrumb.module.scss";
import { ChevronRight } from "@untitled-ui/icons-react";

export const BreadCrumb = (props: Props): ReactElement => {
  const { base, items } = props;
  const LinkComponent = props.linkAs ?? "a";

  function printListItem(
    label: string,
    url: string,
    position: number,
    icon?: JSX.Element,
  ): JSX.Element {
    return (
      <React.Fragment key={`f_${position}`}>
        {position > 1 && (
          <ChevronRight
            viewBox="0 0 24 24"
            className={styles["chevron"]}
            width={16}
            height={16}
            aria-hidden="true"
            key={`c_${position}`}
          />
        )}
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          className={styles["item"]}
          key={`l_${position}`}
        >
          <LinkComponent itemProp="item" href={url}>
            {icon ? (
              <>
                <span>{icon}</span>
                <span itemProp="name" style={{ display: "none" }}>
                  {label}
                </span>
              </>
            ) : (
              <span itemProp="name">{label}</span>
            )}
          </LinkComponent>

          <meta itemProp="position" content={position + ""} />
        </li>
      </React.Fragment>
    );
  }

  function printLabel(
    label: string,
    position: number,
    icon?: JSX.Element,
  ): JSX.Element {
    return (
      <React.Fragment key={`fl_${position}`}>
        {position > 1 && (
          <ChevronRight
            viewBox="0 0 24 24"
            className={styles["chevron"]}
            width={16}
            height={16}
            aria-hidden="true"
            key={`cl_${position}`}
          />
        )}
        <li className={styles["item"]} key={`lil_${position}`}>
          {icon ? (
            <>
              <span>{icon}</span>
              <span itemProp="name" style={{ display: "none" }}>
                {label}
              </span>
            </>
          ) : (
            <span itemProp="name">{label}</span>
          )}
        </li>
      </React.Fragment>
    );
  }

  function printBaseBreadcrumb() {
    if (!base) return null;
    if (items?.length === 0) {
      return printLabel(base.label, 1, base.icon);
    } else {
      return printListItem(base.label, base.url, 1, base.icon);
    }
  }

  function printItems() {
    return items.map((item, i) => {
      if (item.url) {
        return printListItem(item.label, item.url, i + 2);
      } else {
        return printLabel(item.label, i + 2);
      }
    });
  }

  return (
    <nav aria-label="Breadcrumb" role="navigation">
      <ul
        className={styles["breadCrumbList"]}
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {base && printBaseBreadcrumb()}
        {items && printItems()}
      </ul>
    </nav>
  );
};

interface Props {
  base?: {
    label: string;
    icon?: JSX.Element;
    url: string;
    onClick?: () => void;
  };
  items: {
    label: string;
    url?: string;
    onClick?: () => void;
  }[];
  linkAs?: React.ElementType;
}
